import React from 'react';
import payment from './../../../images/dashboard/payment.jpg';


const Pay = () => {
    return (
        <div>

            <h2 className="mt-5">Payment System is Coming Soon!!</h2>

            <img className="img-fluid" src={payment} alt="" />



        </div>
    );
};

export default Pay;